import {
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    VALIDATE_PRODUCTS,
    MORE_GET_PRODUCTS,
    GET_PRODUCT_CATOGORY_LIST,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';
import getCategoryAndBrands from './getCategoryAndBrandsSaga';
import getProductsByBrandOrSuperCategory from './getProductsByBrandOrSuperCategorySaga';
import validateProductsSaga from './validateProductsSaga';
import searchProducts from './searchProductsSaga';
import getProductFilterCatogries from './getProductFilterCatogriesSaga';
import { takeEvery, fork, all, takeLatest } from 'redux-saga/effects';

function* watchGetCategoryAndBrandsSaga() {
    yield takeLatest(GET_PRODUCT_BRAND_AND_CATEGORY_DATA, getCategoryAndBrands);
}

function* watchGetProductsByBrandOrSuperCategorySaga() {
    yield takeLatest(
        GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        getProductsByBrandOrSuperCategory
    );
}

function* watchValidateProductsSaga() {
    yield takeEvery(VALIDATE_PRODUCTS, validateProductsSaga);
}

function* watchGetProductsSaga() {
    yield takeEvery(MORE_GET_PRODUCTS, searchProducts);
}

function* watchProductFilterCatogries() {
    yield takeLatest(GET_PRODUCT_CATOGORY_LIST, getProductFilterCatogries);
}
export default function* productGuideRootSaga() {
    yield all([
        fork(watchValidateProductsSaga),
        fork(watchGetCategoryAndBrandsSaga),
        fork(watchGetProductsByBrandOrSuperCategorySaga),
        fork(watchGetProductsSaga),
        fork(watchProductFilterCatogries),
    ]);
}
